import { DateTime } from 'luxon';

export interface IVisitDocumentMetaData {
  type: string;
  value: string | DateTime | number | boolean;
}

export class VisitDocumentMetaData {
  type: string;
  value: string | DateTime | number | boolean;

  constructor(clone: IVisitDocumentMetaData = null) {
    if (clone) {
      this.type = clone.type;
      switch (clone.type) {
        case 'DateTime':
          this.value = clone.value;
          break;
        default:
          this.value = clone.value;
          break;
      }
    }
  }
}
